module.exports = __webpack_public_path__ + "static/logo-white.a3f8129f.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/logo-white.png
// module id = 126
// module chunks = 35783957827783 114276838955818